// extracted by mini-css-extract-plugin
export default {"cursorGrabbing":"ReorderAttachment__cursorGrabbing___U4Q5F","container":"ReorderAttachment__container___jPYdu","skeleton-loading":"ReorderAttachment__skeleton-loading___gbHiO"};